import { Pipe, PipeTransform } from '@angular/core';
import { formatDisplayName } from 'src/app/util/string';

@Pipe({
    name: 'displayName',
    standalone: false
})
export class DisplayNamePipe implements PipeTransform {
  transform(user?: { firstName?: string; lastName?: string; nickname?: string } | null): string {
    return formatDisplayName(user?.firstName, user?.lastName, user?.nickname);
  }
}
